/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { light_offer } from '../models/light_offer';
import type { offer } from '../models/offer';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OfferService {
    /**
     * Get `Offers` paginated list.
     *
     * @param memberId Member identifier permits to apply personalization
     * @param brandId Brand identifier to filter (not apply if not transmit)
     * @param categoryId Category identifier to filter (not apply if not transmit)
     * @param isBest Best offer filter (not apply if not transmit)
     * @param storeId Store identifier permits to apply product carried `!!JP ONLY!!`
     * @param retailerId Retailer identifier permits to apply personalization
     * @param orderBy Sort order
     * @param perPage Requested count
     * @param page Page number (permits to define offset, start at 1)
     * @returns any Successful operation, returning list.
     * @throws ApiError
     */
    public static getOffers(
        memberId?: number,
        brandId?: number,
        categoryId?: number,
        isBest?: boolean,
        storeId?: number,
        retailerId?: number,
        orderBy?: 'START_DATE_DESC' | 'END_DATE_ASC' | 'DISCOUNT_VALUE_DESC' | 'TARGETED' | 'RANDOM',
        perPage?: number,
        page?: number,
    ): CancelablePromise<{
        /**
         * total entries length
         */
        total?: number;
        /**
         * returned page (start at 1)
         */
        page?: number;
        /**
         * count entries per page
         */
        per_page?: number;
        items?: Array<light_offer>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/offers',
            query: {
                'member_id': memberId,
                'brand_id': brandId,
                'category_id': categoryId,
                'is_best': isBest,
                'store_id': storeId,
                'retailer_id': retailerId,
                'order_by': orderBy,
                'per_page': perPage,
                'page': page,
            },
        });
    }
    /**
     * Get `Offer` detail.
     *
     * @param offerId Offer identifier to retrieve
     * @param storeId Store identifier permits to apply product carried `!!JP ONLY!!`
     * @param retailerId Retailer identifier permits to apply personalization
     * @returns offer Successful operation, returning offer detail.
     * @throws ApiError
     */
    public static getOffers1(
        offerId: number,
        storeId?: number,
        retailerId?: number,
    ): CancelablePromise<offer> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/offers/{offer_id}',
            path: {
                'offer_id': offerId,
            },
            query: {
                'store_id': storeId,
                'retailer_id': retailerId,
            },
        });
    }
    /**
     * Get  `Related Offers` paginated list.
     *
     * @param offerId Offer identifier to retrieve related offers
     * @param memberId Member identifier permits to apply personalization
     * @param storeId Store identifier permits to apply product carried `!!JP ONLY!!`
     * @param retailerId Retailer identifier permits to apply personalization
     * @param perPage Requested count
     * @param page Page number (permits to define offset, start at 1)
     * @returns any Successful operation, returning list.
     * @throws ApiError
     */
    public static getOffersRelated(
        offerId: number,
        memberId?: number,
        storeId?: number,
        retailerId?: number,
        perPage?: number,
        page?: number,
    ): CancelablePromise<{
        /**
         * total entries length
         */
        total?: number;
        /**
         * returned page (start at 1)
         */
        page?: number;
        /**
         * count entries per page
         */
        per_page?: number;
        items?: Array<light_offer>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/offers/{offer_id}/related',
            path: {
                'offer_id': offerId,
            },
            query: {
                'member_id': memberId,
                'store_id': storeId,
                'retailer_id': retailerId,
                'per_page': perPage,
                'page': page,
            },
        });
    }
    /**
     * Get `Offers` paginated list.
     *
     * @param memberId Member identifier permits to apply personalization
     * @param brandId Brand identifier to filter (not apply if not transmit)
     * @param categoryId Category identifier to filter (not apply if not transmit)
     * @param isBest Best offer filter (not apply if not transmit)
     * @param storeId Store identifier permits to apply product carried `!!JP ONLY!!`
     * @param retailerId Retailer identifier permits to apply personalization
     * @param datePc Date format YYYYMMDD
     * @param orderBy Sort order
     * @param perPage Requested count
     * @param page Page number (permits to define offset, start at 1)
     * @returns any Successful operation, returning list.
     * @throws ApiError
     */
    public static getRtdOffers(
        memberId?: number,
        brandId?: number,
        categoryId?: number,
        isBest?: boolean,
        storeId?: number,
        retailerId?: number,
        datePc?: string,
        orderBy?: 'START_DATE_DESC' | 'END_DATE_ASC' | 'DISCOUNT_VALUE_DESC' | 'TARGETED' | 'RANDOM',
        perPage?: number,
        page?: number,
    ): CancelablePromise<{
        /**
         * total entries length
         */
        total?: number;
        /**
         * returned page (start at 1)
         */
        page?: number;
        /**
         * count entries per page
         */
        per_page?: number;
        items?: Array<light_offer>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rtd/offers',
            query: {
                'member_id': memberId,
                'brand_id': brandId,
                'category_id': categoryId,
                'is_best': isBest,
                'store_id': storeId,
                'retailer_id': retailerId,
                'date_pc': datePc,
                'order_by': orderBy,
                'per_page': perPage,
                'page': page,
            },
        });
    }
    /**
     * Get  `Related Offers` paginated list.
     *
     * @param offerId Offer identifier to retrieve related offers
     * @param memberId Member identifier permits to apply personalization
     * @param storeId Store identifier permits to apply product carried `!!JP ONLY!!`
     * @param retailerId Retailer identifier permits to apply personalization
     * @param datePc Date format YYYYMMDD
     * @param perPage Requested count
     * @param page Page number (permits to define offset, start at 1)
     * @returns any Successful operation, returning list.
     * @throws ApiError
     */
    public static getRtdOffersRelated(
        offerId: number,
        memberId?: number,
        storeId?: number,
        retailerId?: number,
        datePc?: string,
        perPage?: number,
        page?: number,
    ): CancelablePromise<{
        /**
         * total entries length
         */
        total?: number;
        /**
         * returned page (start at 1)
         */
        page?: number;
        /**
         * count entries per page
         */
        per_page?: number;
        items?: Array<light_offer>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rtd/offers/{offer_id}/related',
            path: {
                'offer_id': offerId,
            },
            query: {
                'member_id': memberId,
                'store_id': storeId,
                'retailer_id': retailerId,
                'date_pc': datePc,
                'per_page': perPage,
                'page': page,
            },
        });
    }
}
